import { SliderInput } from '@meitu/saas-ui';
import { IImageEffectShadow } from '@meitu/saas-editor-core/es/version-types';
import { ColorGroup } from '@meitu/xdesign-widgets';
import LabelAction from '@/components/label-action';
import { useLocaleStore } from '@/i18n';
import { getColorAlpha, transferColorOpacity } from '../../utils';

const LightProjectionShadowItem: React.FC<{
    shadow: IImageEffectShadow;
    updateData: (data: { key: string; value: any }[], pushHistory?: boolean, stopUpdate?: boolean) => void;
}> = ({ shadow, updateData }) => {
    const { $t } = useLocaleStore();
    const colorChange = (color: string, isEnd = false) => {
        updateData([{ key: 'color', value: color }], isEnd, isEnd);
    };
    const alphaChange = (alpha: number, isEnd = false) => {
        updateData(
            [
                {
                    key: 'color',
                    value: transferColorOpacity(shadow?.color || '#000000', alpha),
                },
            ],
            isEnd,
            isEnd,
        );
    };

    const blurChange = (blur: number, isEnd = false) => {
        updateData([{ key: 'blur', value: blur }], isEnd, isEnd);
    };

    const distanceChange = (newDistance: number, isEnd = false) => {
        updateData([{ key: 'distance', value: newDistance }], isEnd, isEnd);
    };

    const directionChange = (newDirection: number, isEnd = false) => {
        updateData([{ key: 'direction', value: newDirection }], isEnd, isEnd);
    };

    const yOffsetChange = (newYOffset: number, isEnd = false) => {
        updateData([{ key: 'y', value: newYOffset }], isEnd, isEnd);
    };

    return (
        <>
            <LabelAction
                title={$t((v) => v.imageEffectPanel.imageShadowItem.color)}
                align
                style={{ marginBottom: '8px' }}
            >
                <ColorGroup
                    popupTriggerSize={{
                        width: 58,
                        height: 26,
                    }}
                    popupOverlayClassName="c-markup-panel__color-picker"
                    placement="topLeft"
                    color={shadow?.color || '#000000'}
                    setColor={(val) => {
                        colorChange(val);
                    }}
                    setColorAfter={(val, _, { isBrandColor }) => {
                        colorChange(val, true);
                        if (isBrandColor) {
                            window._stat_track?.('hb_layers_func_use', {
                                func_id: '9_107',
                            });
                        }
                    }}
                    showIcon={false}
                    onToggleBizTab={(bizTab) => {
                        if (bizTab === 'team') {
                            window._stat_track?.('hb_layers_func_click', {
                                func_id: '9_107',
                            });
                        }
                    }}
                />
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.blur)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={0}
                        max={100}
                        value={shadow?.blur ? shadow.blur * 100 : 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            blurChange(val / 100);
                        }}
                        onAfterChange={(val: number) => {
                            blurChange(val / 100, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.direction)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={-100}
                        max={100}
                        value={shadow?.direction || 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            directionChange(val);
                        }}
                        onAfterChange={(val: number) => {
                            directionChange(val, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.length)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={0}
                        max={100}
                        value={shadow?.distance || 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            distanceChange(val);
                        }}
                        onAfterChange={(val: number) => {
                            distanceChange(val, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.dis)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={-100}
                        max={100}
                        value={shadow?.y || 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            yOffsetChange(val);
                        }}
                        onAfterChange={(val: number) => {
                            yOffsetChange(val, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.opacity)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={0}
                        max={100}
                        value={getColorAlpha(shadow?.color || '#000000')}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            alphaChange(val);
                        }}
                        onAfterChange={(val: number) => {
                            alphaChange(val, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>
        </>
    );
};

export default LightProjectionShadowItem;
